import React from "react";
import { Col, Row } from "react-bootstrap";

import infoRow from "../../../../components/InfoRow/InfoRow";
import translate from "../../../../services/Translate";

const ModulePole = ({ module, language }: { module: any; language: string }) => {
  const pole = module?.origin_program?.pole;

  if (!pole) {
    return <div className="text-muted mt-4 s-regular">{translate(language, "PAGES.MODULE.POLE.NO_POLE")}</div>;
  }

  return (
    <div className="col-lg">
      <h3 className="mb-3 m-bold">{translate(language, "PAGES.MODULE.POLE.TITLE")}</h3>

      <Row>
        <Col md={6}>
          {infoRow("dst-icon-briefcase-02", translate(language, "PAGES.MODULE.POLE.NAME"), pole?.name)}
          {infoRow("dst-icon-align-left", translate(language, "PAGES.MODULE.POLE.DESCRIPTION"), pole?.description)}
        </Col>

        <Col md={6}>
          {infoRow(
            "dst-icon-user-01",
            translate(language, "PAGES.MODULE.POLE.MANAGER"),
            `${pole?.manager?.first_name ?? ""} ${pole?.manager?.last_name ?? ""}`
          )}
          {infoRow("dst-icon-mail-01", translate(language, "PAGES.MODULE.POLE.MANAGER_EMAIL"), pole?.manager?.email)}
        </Col>
      </Row>

      <div className="d-flex align-items-center justify-content-between my-3">
        <h3 className="mb-0 m-bold">{translate(language, "PAGES.MODULE.POLE.SCHOOL.TITLE")}</h3>
      </div>

      {infoRow(
        "dst-icon-graduation-hat-01",
        translate(language, "PAGES.MODULE.POLE.SCHOOL.NAME"),
        pole?.school?.name,
        pole?.school?.logo_link && (
          <img src={pole.school.logo_link} alt={pole.school.name} className="img-fluid" style={{ maxHeight: 30 }} />
        )
      )}

      {pole?.school?.description && <p>{pole.school.description}</p>}
    </div>
  );
};

export default ModulePole;
